import TripItemFlightRecommendation from './trip-item-flight-recommendation-component';
import TripItemFlightRecommendationService from './trip-item-flight-recommendation-service';

import './trip-item-flight-recommendation.scss';

const MODULE_NAME = 'app.trip.item-flight-recommendation';
const module = angular.module(MODULE_NAME, [])
    .directive(TripItemFlightRecommendation.DIRECTIVE_NAME, TripItemFlightRecommendation)
    .service('tripItemFlightRecommendationService', TripItemFlightRecommendationService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-recommendation/trip-item-flight-recommendation/trip-item-flight-recommendation-module.js